export default (obj, ...omittedkeys) =>
    Object.entries(obj).reduce((reduced, [key, val]) => {
        return omittedkeys.includes(key) ? reduced : { ...reduced, [key]: val };
    }, {});
